import api from '../../api';
import { ApiSuccessResponse } from '../../types';
import {
  CreateResponse,
  ListResponse,
  ViewResponse,
  UpdateResponse,
  DeleteResponse,
  ItemCreateResponse,
  ItemUpdateResponse,
  ItemDeleteResponse,
} from './types';

const PAGING_LIMIT = 100;

type ListRes = ApiSuccessResponse<ListResponse>;

const list = () =>
  api.get<ListRes>('/ingredient-groups', {
    params: {
      per_page: PAGING_LIMIT,
    },
  });

type ViewRes = ApiSuccessResponse<ViewResponse>;
const view = (id: string) => api.get<ViewRes>(`/ingredient-groups/${id}`);

type CreatRes = ApiSuccessResponse<CreateResponse>;
const create = (name: { [key: string]: string }) =>
  api.post<CreatRes>('/ingredient-groups', {
    name,
  });

type UpdateRes = ApiSuccessResponse<UpdateResponse>;
const update = (params: { id: string; name: { [key: string]: string } }) =>
  api.put<UpdateRes>(`/ingredient-groups/${params.id}`, {
    id: params.id,
    name: params.name,
  });

type DeleteRes = ApiSuccessResponse<DeleteResponse>;
const remove = (id: string) =>
  api.delete<DeleteRes>(`/ingredient-groups/${id}`);

type ItemCreatRes = ApiSuccessResponse<ItemCreateResponse>;
const itemCreate = (params: {
  groupId: string;
  name: { [key: string]: string };
}) =>
  api.post<ItemCreatRes>(`/ingredient-groups/${params.groupId}/items`, {
    name: params.name,
  });

type ItemUpdateRes = ApiSuccessResponse<ItemUpdateResponse>;
const itemUpdate = (params: {
  id: string;
  name: { [key: string]: string };
  groupId: string;
}) =>
  api.put<ItemUpdateRes>(
    `/ingredient-groups/${params.groupId}/items/${params.id}`,
    {
      id: params.id,
      name: params.name,
    },
  );

type ItemRemoveRes = ApiSuccessResponse<ItemDeleteResponse>;
const itemRemove = (groupId: string, id: string) =>
  api.delete<ItemRemoveRes>(`/ingredient-groups/${groupId}/items/${id}`);

export default {
  list,
  view,
  create,
  update,
  remove,
  itemCreate,
  itemUpdate,
  itemRemove,
};
